<template>
    <div>
        <textarea :placeholder="$t('fillInAnswer')" :readonly='answerStatus ? "readonly" : null ' v-model='textInput'></textarea>
        <question-analyze v-if='answerStatus' :inside='analysis'></question-analyze>
        <sub-btn @sub-answer="subAnswer" v-if="!answerStatus"></sub-btn>
    </div>
</template>
<script>
import QuestionAnalyze from 'components/PC/QuestionAnalyze'
import SubBtn from 'components/PC/SubBtn'
import psCommonMethods from './mixins/index.js'
export default {
  name: 'Question',
  mixins: [psCommonMethods],
  data () {
    return {
      answerStatus: false,
      dataList: null,
      testTitleTxt: null,
      textInput: '',
      analysis: null
    }
  },
  created () {
    // this.dataList = this.fakeDataList;
    this.initData()
  },
  watch: {
    '$route' () {
      this.initData()
    }
  },
  components: {
    QuestionAnalyze,
    SubBtn
  },
  methods: {
    initData () {
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      let data = this.data.part_list[pIndex].chapter_list[cIndex]
      this.testTitleTxt = data.chapter_content.quiz_title
      this.dataList = data.chapter_content.dry[0]
      this.textInput = data.chapter_content.dry[0].answer
      this.answerStatus = data.answerShow
      this.analysis = data.chapter_content.feedback.right
    },
    subAnswer () {
      if (!this.textInput) {
        this.subAnswerAllow(true) // 显示全局提示
      } else {
        this.answerStatus = true
        this.dataList.answer = this.textInput
        const subAnsArr = []
        subAnsArr[0] = this.dataList
        this.setChaperAnswer(subAnsArr)// 提交用户答案
        // this.setLessonLocation(this.$store.state.currentPartIndex,this.$store.state.currentChapterIndex);
      }
    }
  }
}
</script>
<style lang="less" scoped>
    textarea{
        margin:40px 20px 18px;
        padding:24px 27px;
        width: calc(100% - 40px);
        height:136px;
        border:1px solid #d9ddde;
        border-radius:4px;
        line-height:20px;
        resize:none;
        outline:none;
        box-sizing: border-box;
    }
</style>
